import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ThemeProvider } from 'mineral-ui/themes';
import { getTheme } from '../modules/selectors';

const propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

function ThemeOverrides({ children, theme }) {
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}

function mapStateToProps(state) {
  return {
    theme: getTheme(state),
  };
}
ThemeOverrides.propTypes = propTypes;
export default connect(mapStateToProps)(ThemeOverrides);
